import PhoneRecoveryForm from './PhoneRecoveryForm';

export default PhoneRecoveryForm;
